import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { colors, typography } from '../constants/theme';

interface BadgeProps {
  count: number;
  size?: 'small' | 'medium' | 'large';
  color?: string;
}

const Badge = ({ count, size = 'medium', color = colors.primary }: BadgeProps) => {
  if (count <= 0) return null;
  
  // Determinar tamaño del badge
  const badgeSize = {
    small: 16,
    medium: 20,
    large: 24
  }[size];

  // Determinar tamaño de fuente
  const fontSize = {
    small: typography.fontSize.xs,
    medium: typography.fontSize.sm,
    large: typography.fontSize.md
  }[size];

  return (
    <View style={[
      styles.badge, 
      { 
        width: badgeSize, 
        height: badgeSize, 
        backgroundColor: color,
        // Si el conteo es mayor a 9, hacemos el badge un poco más ancho
        minWidth: count > 9 ? badgeSize * 1.4 : badgeSize 
      }
    ]}>
      <Text style={[styles.badgeText, { fontSize }]}>
        {count > 99 ? '99+' : count}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  badge: {
    position: 'absolute',
    top: -5,
    right: -10,
    borderRadius: 100,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10
  },
  badgeText: {
    color: colors.white,
    fontWeight: 'bold',
  }
});

export default Badge; 